<template>
    <div class="fieldGroupContainer flex-column">
        <template v-for="option in completeInputs">
            <div class="fieldGroup"
            :class="option.category == 'userComments' ? 'bye-bye' : ''">
                <div class="flex-row flex-align-start">
                    <label :for="option.category" :class="option.required ? 'requiredLabel': ''">{{ capitalizeStr(option.category) }}</label>
                    <template v-if="option.toolTip">
                        <button class="btn-svg-transparent flex-row" @click.prevent="handleToolTip(option.category)">
                            <svg-icon-container
                                focusable="false" 
                                :icon="'helpIcon'"
                                :title="option.category + ' Tool Tip'">
                            </svg-icon-container>
                        </button>
                    </template>
                </div>
                <template v-if='option.type === "select"'>
                    <template v-if="option.category === 'status'">
                        <select v-model="formInfo['status']" 
                                class="form-control"
                                id="status" 
                                name="status"
                                :class="requiredInputsObj[option.category] ? 'requiredInput': ''"
                                :required="option.required">
                            <option value="Active" selected>
                                Active
                            </option>
                            <option value="Inactive">
                                Inactive
                            </option>
                        </select>
                    </template>
                    <template v-else>
                        <select v-model="formInfo[option.category]" 
                                class="form-control"  
                                :id="option.category" 
                                :name="option.category" 
                                :class="requiredInputsObj[option.category] ? 'requiredInput': ''"
                                :required="option.required"
                                @change="changeExpiration(option.category)">
                            <option value="">
                            </option>
                            <template v-if="hasFrequency(selectData[option.category])">
                                <option v-for="(item, key) in selectData[option.category]" :value="item.name">
                                    {{item.name}}
                                </option>
                            </template>
                            <template v-else>
                                <option v-for="(item, key) in selectData[option.category]" :value="item">
                                    {{item}}
                                </option>
                            </template>
                        </select>
                    </template>
                </template>
                <template v-else>
                    <template v-if="option.category == 'userComments'">
                        <textarea v-model="formInfo[option.category]" 
                            :id="option.category" 
                            :name="option.category" 
                            class="form-control userComments">
                        </textarea>
                    </template>
                    <template v-else>
                        <input v-model="formInfo[option.category]" 
                            :id="option.category" 
                            :name="option.category" 
                            class="form-control" 
                            :class="requiredInputsObj[option.category] ? 'requiredInput': ''"
                            :type="option.type" 
                            :required="option.required"
                            :aria-describedby="option.toolTip ? option.category + 'ToolTip' : ''"
                            @change="changeExpiration(option.category)">
                    </template>
                </template>
                <span 
                    v-if="option.required" 
                    v-show="requiredInputsObj[option.category]"
                    class="requiredText">{{validationMessages[option.category]}}
                </span>
            </div>
            <div v-if="option.toolTip" v-show="toolTips[option.category]" role="tooltip" :id="option.category + 'ToolTip'">
                <div class="flex-row">
                    <button class="btn-svg-transparent flex-right" @click.prevent="handleToolTip(option.category)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
                        <title>Close Tool Tip</title>
                            <path
                                fill="currentColor"
                                d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                            >
                            </path>
                        </svg>
                    </button>
                </div>
                <div class="flex-row flex-align-start flex-no-wrap tooltip-svg">
                    <svg-icon-container
                        focusable="true" 
                        :hidden="false"
                        :icon="'helpIcon'"
                        :title="'Tool Tip'">
                    </svg-icon-container>
                    <p>{{ option.toolTip }}</p>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import SvgIconContainer from "../components/Svg/SvgIconContainer.vue";
import generalUtilMixins from '../utilities/generalUtilMixins';

export default {
  name: 'simple-input',
  components: {
    SvgIconContainer
  },
  mixins: [generalUtilMixins],
  props: {
    inputs: Array,
    checkValidity: Boolean,
    checkSelector: { 
        type: String,
        default () {
            return ".modal-body"
        }
    },
    sentData: {
      type: Object,
      default () {
        return {}
      }
    },
    frequencyData: {
      type: Object,
      default () {
        return {}
      }
    },
    resetForm: Boolean,
  },
  data: function() {
    var toolTipObj = {};
    this.inputs.forEach(function(key) {
        if (key.toolTip) {
            toolTipObj[key.category] = false;
        }
    });
    return {
      selectData: [],
      formInfo: {
          'status': "Active"
      },
      toolTips: toolTipObj,
      requiredInputsObj: {},
      validationMessages: {},
      passwordKeyToCheck: "",
      passwordMismatch: false,
      allowedToUpdate: false,
    };
  },
  computed: {
    completeInputs() {
        var tempArray = JSON.parse(JSON.stringify(this.inputs));
        var findPassKeyIndex = this.searchKey(this.inputs, "password");
        if (findPassKeyIndex >= 0) {
            this.passwordKeyToCheck = this.inputs[findPassKeyIndex].category;
            tempArray.splice(
                findPassKeyIndex + 1,
                0,
                {
                    'type': "password",
                    'category': "confirmPassword",
                    'required': true
                }
            );
        }

        tempArray.forEach(key => {
            if (key.required) {
                this.requiredInputsObj[key.category] = false;
            }
        });

        return tempArray;
    }
  },
  mounted() {
    for ( var key in this.inputs ) {
        if (this.sentData) {
            this.formInfo[this.inputs[key]['category']] = this.sentData[this.inputs[key]['category']];
        } else {
            if (this.inputs[key]['category'] != "status"){
                this.formInfo[this.inputs[key]['category']] = "";
            }
        }
    }
  },
  methods: {
    searchKey (arr, key) {
        var tempArray = arr.findIndex(element => (element.category).toLowerCase().includes(key) && element.category != "currentPassword");
        return tempArray;
    },
    getCategories() {
      //this.selectData = this.$store.getters.activeCategories;      
    },
    validateEmail(email) {
        let test = String(email)
            .toLowerCase()
            .match(
                /^\S+@\S+\.\S+$/
            );
        return test;
    },
    changeExpiration(category){
        let acceptedCats = ['dateIssued', 'trainingCourse'];
        if (acceptedCats.includes(category)) {
            if (this.selectData['trainingCourse']){
                var findCourse = this.selectData['trainingCourse'].find(obj => {
                    return obj === this.formInfo['trainingCourse']
                })

                if (typeof findCourse !== 'undefined') {
                    if (typeof this.frequencyData['trainingCourse'][this.formInfo['trainingCourse']] !== 'undefined') {
                        if (this.frequencyData['trainingCourse'][this.formInfo['trainingCourse']] && this.frequencyData['trainingCourse'][this.formInfo['trainingCourse']] != "") {
                            var recupDate = new Date(this.formInfo['dateIssued']);
                            var addYears = new Date(recupDate.setFullYear(recupDate.getFullYear() + parseInt(this.frequencyData['trainingCourse'][this.formInfo['trainingCourse']])));
                            this.formInfo['dateExpired'] = this.$options.filters.filterDateFront(addYears);
                        } else {
                            this.formInfo['dateExpired'] = "";
                        }
                    } else {
                        this.formInfo['dateExpired'] = "";
                    }
                }
            }
        }
    },
    isEmptyObject(obj){
        return Object.keys(obj).length === 0;
    },
    hasFrequency(array) {
        try {
            if (array.some(e => 'frequency' in e)) {
                return true;
            } 
        } catch (error) {
            return false;
        }
    },
    handleToolTip(id) {
        this.toolTips[id] = !this.toolTips[id];
    }
  },
  watch: {
    checkValidity(value) {
        if (value) {
            this.validationMessages = {};
            let selector = this.checkSelector + " [required]"
            let requiredInputs = document.querySelectorAll(selector);
            let checkReqInputs = [...requiredInputs].filter((input) => {               
                if (!input.value) {
                    this.validationMessages[input.name] = "This field is required.";
                    return input.value == "";
                }
            });

            //Check email if it isn't blank
            if (!checkReqInputs.some(obj => obj.type == "email")) {
                if (!this.validateEmail(this.formInfo['email'])) {
                    this.validationMessages['email'] = "Email is an invalid format.";
                } else {
                    this.validationMessages['email'] = "";
                }
            }

            if (!checkReqInputs.some(obj => obj.type == "password")) {
                if ((this.formInfo[this.passwordKeyToCheck] != this.formInfo['confirmPassword'])) {
                    this.validationMessages[this.passwordKeyToCheck] = "Passwords do not match.";
                    this.validationMessages['confirmPassword'] = "Passwords do not match.";
                    this.passwordMismatch = true;
                } else {
                    this.validationMessages[this.passwordKeyToCheck] = "";
                    this.validationMessages['confirmPassword'] = "";
                    this.passwordMismatch = false;
                }
            }

            if (checkReqInputs.length > 0 || this.passwordMismatch) {

                this.completeInputs.forEach((key) => {
                    if (key.required) {
                        this.requiredInputsObj[key.category] = false;
                    }
                });

                if (checkReqInputs.length > 0) {
                    checkReqInputs.forEach((key) => {
                        this.requiredInputsObj[key.name] = true;
                    });
                }

                if (this.validationMessages['email'] != "") {
                    this.requiredInputsObj['email'] = true;
                }


                if (this.validationMessages[this.passwordKeyToCheck] && this.validationMessages[this.passwordKeyToCheck] != "") {
                    this.requiredInputsObj[this.passwordKeyToCheck] = true;
                    this.requiredInputsObj['confirmPassword'] = true;
                }

                this.$emit("valid", {'passed': false});
            } else {                
                this.$emit("valid", {'passed': true, 'updatedValues': this.formInfo});
            }
        }
    },
    sentData() {
        for ( var key in this.inputs ) {
            if (this.inputs[key]['category'] != "status"){
                if (key.includes("date") && this.sentData[this.inputs[key]['category']] == "") {
                    var getValue= document.getElementById("dateIssued");
                    getValue.value = this.sentData[this.inputs[key]['category']];
                } else {
                    this.formInfo[this.inputs[key]['category']] = this.sentData[this.inputs[key]['category']];
                }
            } else {
                this.formInfo['status'] = "Active";
            }
        }
    },
    resetForm(value) {
        if (value) {
            for (let i = 0; i < this.completeInputs.length; i++) {
                this.formInfo[this.completeInputs[i]['category']] = "";
                this.requiredInputsObj[this.completeInputs[i]['category']] = false;
            }
        }
    }
  }
};
</script>
